import React from "react";

const Heading3= ({text}) =>{
    return (
        <h3 className="mb-[8px] text-[16px] text-[#2B5388] font-bold">{text}</h3>
    )
}

export default Heading3;